import { render, staticRenderFns } from "./Glosario.vue?vue&type=template&id=1a964460&lang=pug&"
import script from "./Glosario.vue?vue&type=script&lang=js&"
export * from "./Glosario.vue?vue&type=script&lang=js&"
import style0 from "./Glosario.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports